/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Warm_Lynx_LeapInputs */

const en_calm_warm_lynx_leap = /** @type {(inputs: Calm_Warm_Lynx_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove`)
};

const de_calm_warm_lynx_leap = /** @type {(inputs: Calm_Warm_Lynx_LeapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen`)
};

/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Calm_Warm_Lynx_LeapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const calm_warm_lynx_leap = /** @type {((inputs?: Calm_Warm_Lynx_LeapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Warm_Lynx_LeapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calm_warm_lynx_leap(inputs)
	return de_calm_warm_lynx_leap(inputs)
});